import PropTypes from 'prop-types';
import React from 'react';

import { Box, Flex } from '../grid';
import { cmsImagesPropTypes } from '../../prop-types';
import { Divider } from '../divider';
import { H2 } from '../typography';
import { imageTransform } from '../../content/transforms';
import { RecipeMethodItem } from './recipe-method-item';

const RecipeMethod = ({ method }) => (
  <Flex p={1} justifyContent="center" bg="white" flexDirection="column" width="100%">
    <H2>Method</H2>
    <nav>
      {method.map(({ step, image }, index) => {
        const transformedImage = imageTransform(image);
        const hasDivider = method.length - 1 !== index;

        return (
          <div key={step}>
            <RecipeMethodItem image={transformedImage} index={index} step={step} />
            {hasDivider && (
              <Box px={1}>
                <Divider variant="darkGrey" />
              </Box>
            )}
          </div>
        );
      })}
    </nav>
  </Flex>
);

RecipeMethod.propTypes = {
  method: PropTypes.arrayOf(
    PropTypes.shape({
      instruction: PropTypes.string,
      image: cmsImagesPropTypes,
    })
  ).isRequired,
};

export { RecipeMethod };
